import type { MapAdapter } from './MapAdapter';
import { GoogleMapAdapter } from './googleAdapter';
import { fetchMapSettings, getActiveMapApiKey, isMapConfigured } from './settings';
import type { MapSettings } from './types';

export async function createMapAdapter(settings?: MapSettings): Promise<MapAdapter> {
  const resolved = settings ?? (await fetchMapSettings());
  if (!isMapConfigured(resolved)) {
    throw new Error('Google Maps API key is not configured in Admin Settings');
  }
  return new GoogleMapAdapter(resolved.googleApiKey);
}

export { fetchMapSettings, getActiveMapApiKey, isMapConfigured };
